import styled from 'styled-components';
import { gameLiveCasinoDataSelector, useLiveCasinoSelector } from '~/components/live-casino/ducks/selectors';
import useFormatCurrency from '~/hooks/use-format-currency';

const CardBottomContainer = styled.div`
	width: 100%;
	margin-top: 6px;
	height: var(--gameCardBottomInfoHeight);
`;
const GameName = styled.div`
	font: var(--caption-bold);
	margin-bottom: 2px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
const SecondLine = styled.div`
	display: flex;
	justify-content: start;
	align-items: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
const MinBetAmount = styled.div`
	font: var(--small);
	color: var(--main-text-primary, rgba(var(--font-brand-01), 1));
`;
const MidDot = styled.div`
	padding: 0 3px;
	font-size: 13px;
	line-height: 3px;
	color: var(--main-text-supportive, rgba(var(--font-supportive), 1));
`;
const ProviderName = styled.div`
	font: var(--small);
	color: rgba(var(--font-supportive), 1);
`;

function hasDecimal(value) {
	return Number.isFinite(value) && !Number.isInteger(value);
}

const GameCardBottomInfo = props => {
	const formatCurrency = useFormatCurrency();
	const gameLiveCasinoData = useLiveCasinoSelector(state => gameLiveCasinoDataSelector(state, props.game));
	const minBet = gameLiveCasinoData?.betLimits?.min;
	const shouldHideDecimals = !hasDecimal(minBet);

	const minBetAmount = formatCurrency({
		value: minBet,
		hideDecimals: shouldHideDecimals // hide decimals if value is an integer
	});

	return (
		<CardBottomContainer>
			<GameName>{props?.game?.name}</GameName>
			<SecondLine>
				<MinBetAmount>{minBetAmount}</MinBetAmount>
				{minBetAmount && <MidDot>&bull;</MidDot>}
				<ProviderName>{props?.game?.provider?.name}</ProviderName>
			</SecondLine>
		</CardBottomContainer>
	);
};

export default GameCardBottomInfo;
